import { GET_ORDER_ADJUSTMENTS } from '../actionTypes/OrderActionTypes';

export default function OrderAdjustmentsReducer(state = [], action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case GET_ORDER_ADJUSTMENTS:
            return action.payload;
        default:
            return state;
    }
}
